export default {
  mutations: {
    updateInspections(state, inspection) {
      state.inspection = inspection;
    }
  },
  state: {
    inspection: {
      inspectionList: [],
      _meta: {
        pageCount: 0,
        currentPage: 0,
        totalCount: 0,
        perPage: 0
      }
    }
  },
  getters: {
    allInspections(state) {
      return state.inspection.inspectionList;
    },
    inspectionTotalCount(state) {
      return state.inspection._meta.totalCount;
    },
    inspectionPageTotal(state) {
      return state.inspection._meta.pageCount;
    },
    inspectionCurrentPage(state) {
      return state.inspection._meta.currentPage;
    },
    inspectionIsFirstPage(state) {
      return state.inspection._meta.currentPage === 1;
    },
    inspectionIsLastPage(state) {
      return state.inspection._meta.currentPage === state.inspection._meta.pageCount;
    }
  }
}
